<template>
  <section class="section small-padding">
    <div class="container">
      <div class="row">
          <div class="center-block">
            <h2>Estadísticas</h2>
          </div>  
      </div>     
      <div class="panel-group smart-accordion-default" id="accordion">
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" :href="'#stats-hoy'">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>PEDIDOS PARA EL DIA DE HOY {{fechaHoy}}</b></h2>
                        </a>
                      </div>
                    </div>
                    <div :id="'stats-hoy'" class="panel-collapse collapse in">
                          <div class="box-style line-top">
                              <div class="box-style line-top smart-form">
                                <div class="box-header-lg row">
                                  <div class="col-md-8">
                                  </div>
                                  <div class="col-md-4">
                                    <label>EMPRESA</label>
                                    <select class="form-control select2 filter-select2" ref="slEmpresaHoy" multiple style="z-index:1000; width:100%!important; max-width:100%;" data-select2-container="big-text">
                                      <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.empresa.razonSocial}} - {{empresa.denominacion}}</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                              <div class="box-body">
                                <div class="row">
                                  <div class="col-md-12 text-center" v-if="entregasHoyLoading">
                                    <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                  </div>
                                  <div v-if="!entregasHoyLoading&&pedidosHoy==0&&entregasHoyFiltradas.length==0" class="text-center">
                                    <h2>No hay pedidos en el día de la fecha</h2>
                                  </div>
                                    <div v-if="pedidosHoy>0" class="text-center col-xs-3 col-sm-3 col-md-3 col-lg-3" style="padding-left:5px; padding-right:5px;">
                                      <label>TOTALES</label>

                                      <div class="well bg-primary">
                                      <div class="horizontal statistic">
                                          <div class="row">
                                            <div class="horizontal statistic">
                                              <div class="value ranking">{{pedidosHoy}}</div>
                                                <div class="label">Pedidos</div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="horizontal statistic small">
                                              <div class="value">{{pedidosHoyTotal | formatearMoneda}}</div>
                                                <div class="label"></div>
                                            </div>
                                          </div>
                                      </div>
                                      </div>
                                    </div>
                                  <template v-for="(entrSuc,idx) in entregasHoyFiltradas" >   
                                    <div :key="entrSuc.sucursal._id" class="text-center col-xs-3 col-sm-3 col-md-3 col-lg-3" style="padding-left:5px; padding-right:5px;">
                                      <div class="well">
                                      <label>{{entrSuc.sucursal.empresa.razonSocial}} - {{entrSuc.sucursal.denominacion}}</label>
                                      <div class="horizontal statistic">
                                          <div class="row">
                                            <div class="horizontal statistic">
                                              <div class="value ranking" v-bind:class="['p'+idx.toString()]">{{entrSuc.size}}</div>
                                                <div class="label">Pedidos</div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="horizontal statistic small">
                                              <div class="value">{{entrSuc.amount | formatearMoneda}}</div>
                                                <div class="label"></div>
                                            </div>
                                          </div>
                                      </div>
                                      </div>
                                    </div>

                                  </template>
                                </div>      
                              </div>
                           </div>
                   </div>
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" class="collapsed" :href="'#stats-pedidos'">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>PEDIDOS</b></h2>
                        </a>
                      </div>
                    </div>
                    <div :id="'stats-pedidos'" class="panel-collapse collapse">                   
                          <div class="box-style line-top">
                              <div class="box-style line-top smart-form">
                                <div class="box-header-lg row">
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>DESDE</label>
                                      <date-picker ref="pickerDesde" v-model="fechaDesde"></date-picker>
                                    </div>
                                  </div>
                                  <div class="col-md-4">
                                    <div class="form-group">
                                      <label>HASTA</label>
                                      <date-picker ref="pickerHasta" v-model="fechaHasta"></date-picker>
                                    </div>                  
                                  </div>
                                  <div class="col-md-4">
                                    <label>EMPRESA</label>
                                    <select class="form-control select2 filter-select2" ref="slEmpresa" multiple style="z-index:1000; width:100%!important; max-width:100%;" data-select2-container="big-text">
                                      <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.empresa.razonSocial}} - {{empresa.denominacion}}</option>
                                    </select>
                                  </div>
                                  <div class="col-md-1" style="padding-top:22px;">
                                    <a class="btn btn-success btn-fill" @click.prevent="filtrarEntregas()">Aplicar</a>
                                  </div>
                                </div>
                              </div>
                              <div class="box-body">
                                <div class="row">
                                  <div class="col-md-12 text-center" v-if="entregasLoading">
                                    <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                  </div>
                                  <div v-if="!entregasLoading&&pedidosFiltrados==0&&entregasFechasFiltradas.length==0&&fechaDesde&&fechaHasta" class="text-center">
                                    <h2>No hay pedidos en el rango de fechas seleccionado</h2>
                                  </div>
                                  <div v-if="!entregasLoading&&(!fechaDesde||!fechaHasta)" class="text-center">
                                    <h2>Seleccione el rango de fechas y haga click en "Aplicar"</h2>
                                  </div>
                                    <div v-if="pedidosFiltrados>0" class="text-center col-xs-3 col-sm-3 col-md-3 col-lg-3" style="padding-left:5px; padding-right:5px;">
                                      <label>TOTALES</label>
                                      <div class="well bg-primary">
                                      <div class="horizontal statistic">
                                          <div class="row">
                                            <div class="horizontal statistic">
                                              <div class="value ranking">{{pedidosFiltrados}}</div>
                                                <div class="label">Pedidos</div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="horizontal statistic small">
                                              <div class="value">{{pedidosFiltradosTotal | formatearMoneda}}</div>
                                                <div class="label"></div>
                                            </div>
                                          </div>
                                      </div>
                                      </div>
                                    </div>


                                  <template v-for="(entrSuc,idx) in entregasFechasFiltradas" >   
                                    <div :key="entrSuc.sucursal._id" style="padding-left:5px; padding-right:5px; min-height:300px;" class="text-center col-xs-3 col-sm-3 col-md-3 col-lg-3">
                                      <div class="well">
                                        <label>{{entrSuc.sucursal.empresa.razonSocial}} - {{entrSuc.sucursal.denominacion}}</label>
                                        <div class="horizontal statistic">
                                            <div class="row">
                                              <div class="horizontal statistic">
                                                <div class="value ranking" v-bind:class="['p'+idx.toString()]">{{entrSuc.size}}</div>
                                                  <div class="label">Pedidos</div>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div class="horizontal statistic small">
                                                <div class="value">{{entrSuc.amount | formatearMoneda}}</div>
                                                  <div class="label"></div>
                                              </div>
                                            </div>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </div>      
                              </div>
                           </div> 
                    </div>  
                    <div class="panel-heading">
                      <div class="panel-title box-header">
                        <a data-toggle="collapse" class="collapsed" :href="'#stats-ranking'">
                          <i class="fa fa-lg fa-angle-down pull-right"></i>
                          <i class="fa fa-lg fa-angle-up pull-right"></i>
                          <h2><b>RANKING DE PLATOS</b></h2>
                        </a>
                      </div>
                    </div>
                    <div :id="'stats-ranking'" class="panel-collapse collapse">
                        <div class="box-style line-top">
                                <div class="box-header-lg row">
                                  <div class="col-md-3">
                                    <div class="form-group">
                                      <label>DESDE</label>
                                      <date-picker ref="pickerDesde" v-model="fechaDesdeRanking" :max-date="new Date()"></date-picker>
                                    </div>
                                    <div class="form-group">
                                      <label>HASTA</label>
                                      <date-picker ref="pickerHasta" v-model="fechaHastaRanking" :max-date="new Date()"></date-picker>
                                    </div>                  
                                  </div>
                                  <div class="col-md-4">
                                    <label>PROVEEDOR</label>
                                    <select class="form-control select2 filter-select2" ref="slProveedor" multiple style="z-index:1000; width:100%!important; max-width:100%;" data-select2-container="big-text">
                                      <option v-for="resto in restaurantes" :key="resto._id" :value="resto._id">{{resto.razonSocial}}</option>
                                    </select>
                                  </div>
                                  <div class="col-md-4">
                                    <label>EMPRESA</label>
                                    <select class="form-control select2 filter-select2" ref="slEmpresaRanking" multiple style="z-index:1000; width:100%!important; max-width:100%;" data-select2-container="big-text">
                                      <option v-for="empresa in empresas" :key="empresa._id" :value="empresa._id">{{empresa.empresa.razonSocial}} - {{empresa.denominacion}}</option>
                                    </select>
                                  </div>
                                  <div class="col-md-1" style="padding-top:22px;">
                                    <a class="btn btn-success btn-fill" @click.prevent="filtrarRanking()">Aplicar</a>
                                  </div>                  
                                </div>

                            <div class="box-body">
                              <div class="row">
                                  <div class="col-md-12 text-center" v-if="rankingLoading">
                                    <i class="fa fa-cog fa-spin fa-3x fa-fw"></i>
                                  </div>
                                <div class="col-md-12">
                                  <template v-for="cat in ranking" v-if="!rankingLoading" >
                                    <div :key="cat.categoria" class="row">
                                      <div class="col-md-12">
                                        <h3>{{cat.categoria}}</h3>
                                        <br/>
                                      </div>
                                    </div>   
                                    <div class="row">
                                      <div class="col-md-12 stats">
                                        <div class="col-md-3 text-center">
                                          <label>Plato</label>
                                        </div>
                                        <div class="col-md-6 text-center">
                                          <label>Cantidad</label>
                                        </div>
                                        <div class="col-md-3">
                                          <label>Pedidos por Empresa</label>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                    <template v-for="(rank, idx) in cat.ranking" >   
                                      <div :key="rank._id" class="col-md-12 stats" v-bind:class="{'bg-grey': idx%2 != 0}">
                                        <div class="col-md-3 horizontal text-center statistic">
                                            <div class="row">
                                              <div class="horizontal statistic xmini">
                                                <div class="value">{{rank.plato.nombre}} ({{rank.proveedor.razonSocial}})</div>
                                              </div>
                                            </div>
                                        </div>
                                        <div class="col-md-6 text-center">
                                            <div class="horizontal statistic">
                                              <div class="horizontal statistic small text-center">
                                                  <div class="value ranking" v-bind:class="['p'+idx.toString()]">{{rank.size}}</div>
                                                  <div class="label">Pedidos</div>
                                              </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3 well" style="padding-top:10px;margin-top:10px;">
                                            <template v-for="cliente in rank.sucs" >
                                              <div class="row" :key="cliente._id">
                                                <div class="horizontal statistic xmini">
                                                  <div class="value">{{cliente.size}}</div>
                                                  <div class="label">{{cliente.sucursal.empresa.razonSocial}} - {{cliente.sucursal.denominacion}}</div>
                                                </div>
                                              </div>
                                            </template>                        
                                        </div>
                                      </div>
                                    </template>                    
                                    </div>
                                  </template>
                                </div>
                              </div>      
                            </div>
                          </div> 
                      </div>
                    </div>
      </div>

    </div>
    </div>
  </section>
</template>
<script>
import '../../assets/css/select2_status.css'
import '../../assets/css/select2.css'
import DatePicker from '../Shared/DatePicker'
import {sortBy, orderBy} from 'lodash'
import moment from 'moment'
import 'select2'
import $ from 'jquery'

moment.locale('es')

export default {
  components: {
    'date-picker': DatePicker
  },
  computed: {
    entregasHoyFiltradas () {
      const me = this
      let entregas = me.entregasSucursalHoy
      if (me.empresasActivasHoy.length > 0) {
        entregas = entregas.filter((entrega) => {
          return me.empresasActivasHoy.includes(entrega.sucursal._id)
        })
      }
      return entregas
    },
    entregasFechasFiltradas () {
      const me = this
      let entregas = me.entregasFiltradas
      if (me.empresasActivas.length > 0) {
        entregas = entregas.filter((entrega) => {
          return me.empresasActivas.includes(entrega.sucursal._id)
        })
      }
      return entregas
    }
  },
  data () {
    return {
      fechaHoy: '',
      empresasActivas: [],
      empresasActivasHoy: [],
      empresasActivasRanking: [],
      restaurantesActivos: [],
      restaurantes: [],
      empresas: [],
      fechaDesde: undefined,
      fechaHasta: undefined,
      fechaDesdeRanking: undefined,
      fechaHastaRanking: undefined,
      entregasSucursalHoy: [],
      entregasFiltradas: [],
      ranking: [],
      entregasHoyLoading: false,
      pedidosHoy: 0,
      pedidosHoyTotal: 0,
      pedidosFiltrados: 0,
      pedidosFiltradosTotal: 0,
      entregasLoading: false,
      rankingLoading: false
    }
  },
  filters: {
    formatearMoneda (value) {
      return '$ ' + parseFloat(value).toFixed(2)
    }
  },
  methods: {
    filtrarRanking () {
      const me = this
      if (me.fechaDesdeRanking && me.fechaHastaRanking) {
        me.rankingLoading = true
        me.$http.post('/api/admin/stats/ranking', {sucursales: me.empresasActivasRanking, fechaDesde: me.fechaDesdeRanking, fechaHasta: me.fechaHastaRanking, proveedores: me.restaurantesActivos}).then(({body}) => {
          me.ranking = body.ranking
          me.rankingLoading = false
        }, (err) => {
          me.rankingLoading = false
          this.$emit('mostrar-notificacion', 'error', err)
        })
      }
    },
    filtrarEntregas () {
      const me = this
      if (me.fechaDesde && me.fechaHasta) {
        me.entregasLoading = true
        me.$http.post('/api/admin/stats/entregas', {sucursales: me.empresasActivas, fechaDesde: me.fechaDesde, fechaHasta: me.fechaHasta}).then(({body}) => {
          me.pedidosFiltrados = body.pedidos
          me.pedidosFiltradosTotal = body.total
          me.entregasFiltradas = []
          $.each(body.pedidosPorSucursal, function (k, v) {
            me.entregasFiltradas.push(v)
          })
          me.entregasFiltradas = orderBy(me.entregasFiltradas, ['size'], ['desc'])
          me.entregasLoading = false
        }, (err) => {
          me.entregasLoading = false
          this.$emit('mostrar-notificacion', 'error', err)
        })
      }
    },
    filtrarEntregasHoy () {
      const me = this
      me.entregasHoyLoading = true
      me.$http.post('/api/admin/stats/entregas', {sucursales: me.empresasActivasHoy}).then(({body}) => {
        me.entregasSucursalHoy = []
        $.each(body.pedidosPorSucursal, function (k, v) {
          me.entregasSucursalHoy.push(v)
        })
        me.pedidosHoy = body.pedidos
        me.pedidosHoyTotal = body.total
        me.entregasSucursalHoy = orderBy(me.entregasSucursalHoy, ['size'], ['desc'])
        me.entregasHoyLoading = false
      }, (err) => {
        me.entregasHoyLoading = false
        this.$emit('mostrar-notificacion', 'error', err)
      })
    }
  },
  mounted () {
    const me = this
    me.$store.dispatch('initStats').then(({body}) => {
      me.restaurantes = sortBy(body.proveedores, p => p.razonSocial)
      me.empresas = sortBy(body.sucursales, s => s.empresa.razonSocial)
      me.fechaHoy = moment(body.hoy).format('dddd DD [de] MMMM [de] YYYY').toUpperCase()
      me.entregasSucursalHoy = []
      me.pedidosHoy = body.pedidos
      me.pedidosHoyTotal = body.total
      $.each(body.pedidosPorSucursal, function (k, v) {
        me.entregasSucursalHoy.push(v)
      })
      me.entregasSucursalHoy = orderBy(me.entregasSucursalHoy, ['size'], ['desc'])
    }, e => console.error(e)).then(() => {
      $(me.$refs.slEmpresa).select2({
        placeholder: 'Seleccione una empresa'
      }).on('change', (e) => {
        me.empresasActivas = $(me.$refs.slEmpresa).val()
        me.filtrarEntregas()
      })
      $(me.$refs.slEmpresaHoy).select2({
        placeholder: 'Seleccione una empresa'
      }).on('change', (e) => {
        me.empresasActivasHoy = $(me.$refs.slEmpresaHoy).val()
        me.filtrarEntregasHoy()
      })
      $(me.$refs.slEmpresaRanking).select2({
        placeholder: 'Seleccione una empresa'
      }).on('change', (e) => {
        me.empresasActivasRanking = $(me.$refs.slEmpresaRanking).val()
      })
      $(me.$refs.slProveedor).select2({
        placeholder: 'Seleccione un proveedor'
      }).on('change', (e) => {
        me.restaurantesActivos = $(me.$refs.slProveedor).val()
      })
      $.datepicker.setDefaults($.datepicker.regional['es'])
      $('.datepicker.desde').datepicker({
        dateFormat: 'dd/mm/yy',
        beforeShowDay: $.datepicker.noWeekends
      }).datepicker('setDate', moment().toDate())
      $('.datepicker.hasta').datepicker({
        dateFormat: 'dd/mm/yy',
        beforeShowDay: $.datepicker.noWeekends
      }).datepicker('setDate', moment().toDate())
    })
  },
  watch: {
    fechaActiva (newVal, oldVal) {
      if (newVal) {
        this.getPedidosDia(newVal)
      } else {
        this.entregas = []
      }
    },
    'pedido.combo': function (newVal, oldVal) {
      const me = this
      const combo = me.combosUsuario.find(c => c._id === newVal)
      if (combo) {
        me.proveedorActivo = combo.proveedor
        me.$refs.precio.value = me.obtenerPrecio(me.comboActivo)
        me.$refs.subsidio.value = me.subsidioActivo
      }
      me.pedido.platos = []
    }
  }
}
</script>
<style scoped>
.modal {
  background-color: white;
}
.derecha {
  text-align: right;
}
.status-recibido {
  background-color: #F28893;
  color: #333;
}
.status-cocina {
  background-color: #FFC182;
  color: #333;
}
.status-empaquetado {
  background-color: #74A9B3;
  color: #333;
}
.status-entregado {
  background-color: #93A512;
  color: #333;
}
.status-cancelado {
  background-color: #666;
  color: #FFF;
}

</style>



// WEBPACK FOOTER //
// Stats.vue?77cd678a